export const WORLD_REPORT_REASON_VALUES = [
  'hate-speech',
  'bullying-or-harassment',
  'threats-or-incitement-of-violence',
  'promoting-or-glorifying-self-harm',
  'spam-or-scams',
  'illegal-content',
  'sharing-private-or-personal-information',
  'other',
] as const

export const KIDS_MODE_WORLD_REPORT_REASON_VALUES = [
  'inappropriate-audio',
  'inappropriate-visuals',
  'other',
] as const

export type WorldReportReason =
  | (typeof WORLD_REPORT_REASON_VALUES)[number]
  | (typeof KIDS_MODE_WORLD_REPORT_REASON_VALUES)[number]

export const WORLD_REPORT_VARIANTS = ['default', 'kids-mode'] as const

export type WorldReportVariant = (typeof WORLD_REPORT_VARIANTS)[number]

export const KIDS_MODE_WORLD_REPORT_VARIANT: WorldReportVariant = 'kids-mode'
